var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:("wrap-" + (_vm.item.con_id)),staticClass:"wrap",class:_vm.item.css_class},[_c('iframe',{ref:("iframe-" + (_vm.item.con_id)),attrs:{"src":_vm.htmlSrc,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }